module.exports = __webpack_public_path__ + "static/media/d3_maze_100.1f9d8c31.ico";